import React from 'react';

const CurrentItemGalleryPlaceholder = () => {
  return <div className="placeholder-gallery__large animation" />;
};

export default CurrentItemGalleryPlaceholder;
